import { Stack, IconButton } from '@mui/material';

interface DirectionArrow {
  onClick: () => void;
  disabled?: boolean;
}

export function PrevNextBrowseArrows(props: {
  previous: DirectionArrow;
  next: DirectionArrow;
}) {
  const { previous, next } = props;
  return (
    <Stack direction='row'>
      <IconButton onClick={previous.onClick} disabled={previous.disabled}>
        <i className='material-symbols-chevron-left-rounded' />
      </IconButton>
      <IconButton onClick={next.onClick} disabled={next.disabled}>
        <i className='material-symbols-chevron-right-rounded' />
      </IconButton>
    </Stack>
  );
}
